import Service from "../../AuthService";

const driverBonus = {
    getDriverBonus(data) {
        return Service.get("/driver-bonus?page="+data.page+'&id='+data.id);
    },
    showDriverBonus(id) {
        return Service.get("/driver-bonus/" + id);
    },
    updateDriverBonus(id, data) {
        return Service.put("/driver-bonus/" + id, data);
    },
    createDriverBonus(data) {
        return Service.post("/driver-bonus", data);
    },
    deleteDriverBonus(id) {
        return Service.delete("/driver-bonus/" + id);
    },
    searchDriverBonus(page,data) {
        return Service.post("/driver-bonus-search?page="+page ,data);
    },
};
export default driverBonus;
